export default "__VITE_ASSET__jAf6bykq__"